import { useMemo } from 'react';

import { useBufferedRanges as useStreamBufferedRanges } from '@/scenarios/legacy-player/hooks/useBufferedRanges';

import { BufferedRange } from '../types/range';
import { Time } from '../types/time';

export const useBufferedRanges: () => BufferedRange[] | undefined = () => {
    const streamBufferedRanges = useStreamBufferedRanges();
    /** @see OTT-82541 if need hide preroll timeline */
    const prerollDuration = 0;

    return useMemo(
        () =>
            streamBufferedRanges?.map((range) => ({
                start: new Time(range.start, prerollDuration ?? 0),
                end: new Time(range.end, prerollDuration ?? 0),
            })),
        [prerollDuration, streamBufferedRanges]
    );
};
